import { render, staticRenderFns } from "./OrderDetailRentACarView.vue?vue&type=template&id=21634c74&scoped=true"
import script from "./OrderDetailRentACarView.vue?vue&type=script&lang=js"
export * from "./OrderDetailRentACarView.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailRentACarView.vue?vue&type=style&index=0&id=21634c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21634c74",
  null
  
)

export default component.exports